import { IMessage } from '@eventr/common'
import { ColoursObj } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { DateTime } from 'luxon'
import { useLanguageContext } from '../../../../state/languageState/languageContext'
import { BigEmoji } from './BigEmoji'
import { CodeBlock } from './CodeBlock'
import { HeadingBlock } from './HeadingBlock'
import { OrderedListBlock } from './OrderedListBlock'
import { ParagraphBlock } from './ParagraphBlock'
import { QuoteBlock } from './QuoteBlock'
import { TaskListBlock } from './TaskListBlock'
import { UnOrderedListBlock } from './UnorderedListBlock'

function Markup(message: IMessage) {
    const tokens = message.md ?? []
    const messageDate = new Date(message.ts)
    return (
        <Stack
            style={{
                width: '100%',
                display: 'flex',
            }}
        >
            <Stack>
                {tokens.map((token, index) => {
                    if (token.type === 'PARAGRAPH') {
                        return (
                            <ParagraphBlock
                                key={index}
                                contents={token.value}
                                messageDate={messageDate}
                            />
                        )
                    } else if (token.type === 'CODE') {
                        return <CodeBlock key={index} lines={token.value} />
                    } else if (token.type === 'BIG_EMOJI') {
                        return <BigEmoji key={index} contents={token.value} />
                    } else if (token.type === 'HEADING') {
                        return (
                            <HeadingBlock
                                key={index}
                                contents={token.value}
                                level={token.level}
                            />
                        )
                    } else if (token.type === 'UNORDERED_LIST') {
                        return (
                            <UnOrderedListBlock
                                key={index}
                                items={token.value}
                            />
                        )
                    } else if (token.type === 'ORDERED_LIST') {
                        return (
                            <OrderedListBlock key={index} items={token.value} />
                        )
                    } else if (token.type === 'TASKS') {
                        return <TaskListBlock key={index} tasks={token.value} />
                    } else if (token.type === 'QUOTE') {
                        return (
                            <QuoteBlock
                                key={index}
                                contents={token.value}
                                messageDate={messageDate}
                            />
                        )
                    } else if (token.type === 'LINE_BREAK') {
                        return <br key={index} />
                    } else {
                        return <div />
                    }
                })}
            </Stack>
            <Stack>
                {!tokens.map((token) => token.type).includes('PARAGRAPH') && (
                    <span
                        style={{
                            fontSize: '12px',
                            lineHeight: '16px',
                            fontWeight: '400',
                            color: ColoursObj.font.primary,
                            paddingLeft: '8px',
                        }}
                    >
                        {DateTime.fromJSDate(messageDate).toFormat(
                            useLanguageContext.getState().timeFormat,
                            {
                                locale: useLanguageContext
                                    .getState()
                                    .getLanguageISO639Code(),
                            }
                        )}
                    </span>
                )}
            </Stack>
        </Stack>
    )
}

export default Markup
